import { render, staticRenderFns } from "./RunnitVideo.vue?vue&type=template&id=1d638fdf&scoped=true"
import script from "./RunnitVideo.vue?vue&type=script&lang=ts"
export * from "./RunnitVideo.vue?vue&type=script&lang=ts"
import style0 from "./RunnitVideo.vue?vue&type=style&index=0&id=1d638fdf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d638fdf",
  null
  
)

export default component.exports